export default __webpack_public_path__ + "static/media/Nik.1b689653.png";